import AddSampleContent from './Add';
import EditSampleContent from './Edit';
import SampleContentList from './List';

export const containers = {
  AddSampleContent,
  EditSampleContent,
  SampleContentList,
};


// WEBPACK FOOTER //
// ./src/modules/admin/sampleContent/containers/index.js